import { Typography } from "@mui/material";

const DateWarning = ({ show, message }) => {
  if (!show) return null;

  return (
    <Typography
      variant="caption"
      sx={{
        color: "#ed6c02",
        fontSize: "0.75rem",
        display: "flex",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      {message}
    </Typography>
  );
};

export default DateWarning;
